// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__TFVvk","table":"Table_table__-6KQk","row":"Table_row__tiCMV","col":"Table_col__g+DBP"};